<template>
    <div class="card shadow topcard">
      
        <div class="highlightdiv">
            <div style="padding-top: 30px; text-align: center; font-weight: bold; font-size: 26px; color: #003;">
                <span>2022 HIGHLIGHTS</span>
            </div>
            <div class="row">
                <div class="innerdiv" v-for="highlight in approachperf">
                    <div class="row">
                        <div class="col-xs-12 col-sm-3 col-md-3 leftside"   style="padding-top: 30px;">
                            <img :src="`${baseimageurl}${highlight.highlightimage}`" class="img-fluid rounded-start" alt="">
                        </div>
                        <div class="col-xs-12 col-sm-9 col-md-9 rightside">
                        <div class="card-body">
                            <span v-html="highlight.highlightdesc"></span>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>

export default {
    props: ['approachperf', 'baseimageurl'],
}
</script>
<style scoped>
.icondiv {
    width: 20%;
}
.textdiv {
    width: 78%;
}


/* Move the background and make it larger. 
/* Media Query CSS*/
@media only screen and (max-width: 600px) {
.leftside {
    text-align: center;
}
.rightside {
    text-align: center;
    padding: 20px;
}
.highlightdiv {
    padding-left: 150px;
}
.topcard {
    padding: 30px;
}
.innerdiv {
    max-width: 430px;
    margin-left: -50px;
}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .innerdiv {
        max-width: 400px;
        
    }
    .topcard {
        margin: 100px;
    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .innerdiv {
        max-width: 400px;
    }
    .topcard {
        margin: 100px;
    }
}


/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .innerdiv {
        max-width: 400px;
    }
    .topcard {
        margin: 100px;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .topcard {
        margin: 100px;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
.innerdiv {
    max-width: 400px;
}
.topcard {
    margin: 100px;
}
}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {
    .topcard {
        margin: 100px;
    }
}
</style>